<template>
    <base-card title="Añadir plantilla" type="primary">
        <form @submit.prevent="store">
            <div class="row">
                <div class="form-group col-md-3 col-12">
                    <label for="">Nombre planilla:</label>
                    <input type="text" class="form-control" v-model="format.name" required>
                </div>
                <div class="form-group col-md-3 col-12">
                    <label for="">Título:</label>
                    <input type="text" class="form-control" v-model="format.title">
                </div>
                <div class="form-group col-md-6 col-12">
                    <label for="">Usuarios planilla (A - Z):</label>
                    <select type="text" multiple class="form-control" v-model="format.user_id" required>
                        <option v-for="user in users" :key="user.id" :value="user.id">{{user.last_name}} {{user.first_name}}</option>
                    </select>
                    <small class="text-gray-600"><b>Tip:</b> mantén presionado [Ctrl] para seleccionar varios usuarios</small>
                </div>
            </div>
            <base-card title="Multimedia" type="warning">
                <div class="row">
                    <div class="col-12 col-sm-3">
                        <div class="form-group">
                            <label class="" for="files">Cantidad de archivos:</label>
                            <input type="number" min="0" max="8" value="0" class="form-control" id="files" v-model="format.files">
                        </div>
                    </div>
                    <div class="col-12 col-sm-3">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="image" v-model="format.image">
                            <label class="custom-control-label" for="image">Permitir imagen</label>
                        </div>
                    </div>
                    <div class="col-12 col-sm-3">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="audio" v-model="format.audio">
                            <label class="custom-control-label" for="audio">Permitir audio</label>
                        </div>
                    </div>
                    <div class="col-12 col-sm-3">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="video" v-model="format.video">
                            <label class="custom-control-label" for="video">Permitir video</label>
                        </div>
                    </div>
                </div>
            </base-card>

            <base-card class="mt-2" title="Asociaciones" type="info">
                <div class="row">
                    <div class="form-group col-md-6">
                        <label for="">Organización:</label>
                        <select v-model="format.city_id" required class="form-control">
                            <option value="">Seleccionar organización</option>
                            <option v-for="city in getCities" :key="city.id" :value="city.id">{{city.name}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="">Dependencia:</label>
                        <select v-model="format.entity_id" required class="form-control">
                            <option value="">Seleccionar dependencia</option>
                            <option v-for="entity in getEntities" :key="entity.id" :value="entity.id">{{entity.name}}</option>
                        </select>
                    </div>
                </div>
            </base-card>

            <base-card v-if="!edit" title="Añadir campos" class="mt-2" type="primary">
                <div class="row">
                    <fields class="col-md-6"></fields>
                    <div class="col-md-6">
                        <ul class="list-group mb-4" v-if="getSelectedFields.length">
                            <li class="list-group-item active">Campos seleccionados</li>
                            <li v-for="(field, i) in getSelectedFields" :key="field.id" class="list-group-item">{{i+1}}. {{field.name}}</li>
                        </ul>
                    </div>
                </div>
            </base-card>
            <input class="btn btn-success mt-4" type="submit" value="Guardar formato">
        </form>
    </base-card>
</template>

<script>
import Fields from '../field/Fields'
import BaseCard from '@/components/base/BaseCard';
import {mapActions, mapGetters} from 'vuex';

function emptyFormat() {
    return {city_id: "", entity_id: "", image: false, audio: false, video: false, user_id: [], files: 0}
}

export default {
    name: "FormatForm",
    components: {
        Fields,
        BaseCard
    },
    props: ['_format'],
    created(){
        this.fetchCities();
        this.fetchEntities();
        this.fetchUsers();

        if(this._format.id){
            this.format = this._format;
            this.edit = true;
        }
    },
    data: () => ({
        format: emptyFormat(),
        edit: false,
    }),
    methods: {
        async store(){
            this.format.field_id = this.getSelectedFields.map(field => field.id);
            if(this.edit){
                await this.updateFormat(this.format);
            } else {
                await this.storeFormat(this.format);
            }

            this.format = emptyFormat();
            this.clearSelected();
            this.$emit('sent');
        },
        ...mapActions(['updateFormat', 'storeFormat', 'fetchCities', 'fetchEntities', 'clearSelected', 'fetchUsers'])
    },
    computed: mapGetters(['getCities', 'getEntities', 'getSelectedFields', 'users'])

}
</script>

<style>

</style>